import styled from "styled-components";

export const ContactInfo = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 5px;
`;
